/**
 * SEZNIK PRO DUAL-TRACK KINETIC PRODUCT MARQUEE JS
 * Continuous RAF loop with scroll momentum & hover physics
 */

class SeznikPromoMarquee {
  constructor(element) {
    this.container = element;
    this.tracks = Array.from(element.querySelectorAll('[data-promo-track]'));
    if (!this.tracks.length) return;

    this.lastScrollY = window.scrollY || window.pageYOffset;
    this.scrollVelocity = 0;
    this.smoothVelocity = 0;
    this.rafId = null;
    this.lastTime = performance.now();
    this.isHovered = false;

    this.trackData = this.tracks.map((track) => {
      const baseVelocity = parseFloat(track.dataset.velocity || '-1.2');
      const scrollBoost = track.dataset.scrollBoost !== 'false';
      return {
        el: track,
        baseVelocity: baseVelocity,
        currentX: 0,
        direction: Math.sign(baseVelocity) || -1,
        scrollBoost: scrollBoost,
        trackWidth: 0,
      };
    });

    this.init();
  }

  init() {
    this.updateDimensions();
    window.addEventListener('resize', () => this.updateDimensions(), { passive: true });
    window.addEventListener('scroll', () => this.onScroll(), { passive: true });

    // Hover slowdown for natural reading & interaction
    this.container.addEventListener('mouseenter', () => {
      this.isHovered = true;
    });
    this.container.addEventListener('mouseleave', () => {
      this.isHovered = false;
    });

    this.lastTime = performance.now();
    this.animate = this.animate.bind(this);
    this.rafId = requestAnimationFrame(this.animate);
  }

  updateDimensions() {
    this.trackData.forEach((item) => {
      // Each track contains 2 duplicate sets of items for seamless infinite wrapping
      item.trackWidth = item.el.scrollWidth / 2;
    });
  }

  onScroll() {
    const currentScrollY = window.scrollY || window.pageYOffset;
    const delta = currentScrollY - this.lastScrollY;
    this.scrollVelocity = delta;
    this.lastScrollY = currentScrollY;
  }

  animate(currentTime) {
    const delta = Math.min((currentTime - this.lastTime) / 1000, 0.1);
    this.lastTime = currentTime;

    // Smooth spring-like velocity interpolation
    this.smoothVelocity += (this.scrollVelocity - this.smoothVelocity) * 0.14;
    this.scrollVelocity *= 0.88;

    const velocityMagnitude = Math.abs(this.smoothVelocity);
    const velocityBoost = Math.min(velocityMagnitude * 0.08, 4.5);
    const speedMultiplier = this.isHovered ? 0.35 : 1.0;

    this.trackData.forEach((item) => {
      if (!item.trackWidth || item.trackWidth <= 0) {
        item.trackWidth = item.el.scrollWidth / 2;
      }

      // Base movement + velocity boost
      const moveRate = (Math.abs(item.baseVelocity) * 28 + (item.scrollBoost ? velocityBoost * 32 : 0)) * speedMultiplier * delta;
      item.currentX += item.direction * moveRate;

      // Wrap seamlessly
      if (item.trackWidth > 0) {
        if (item.direction < 0 && item.currentX <= -item.trackWidth) {
          item.currentX += item.trackWidth;
        } else if (item.direction > 0 && item.currentX >= 0) {
          item.currentX -= item.trackWidth;
        }
      }

      item.el.style.transform = `translate3d(${item.currentX}px, 0, 0)`;
    });

    this.rafId = requestAnimationFrame(this.animate);
  }

  destroy() {
    if (this.rafId) cancelAnimationFrame(this.rafId);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sz-prod-marquee-section, .sz-promo-marquee-section').forEach((el) => {
    new SeznikPromoMarquee(el);
  });
});
